/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Pick_2_PickInputs */

const en_pc_alt_pick_2_pick = /** @type {(inputs: Pc_Alt_Pick_2_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adobe Acrobat or Foxit PDF Editor. PdfCraft does not edit existing text reliably yet.`)
};

const zh_pc_alt_pick_2_pick = /** @type {(inputs: Pc_Alt_Pick_2_PickInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选 Adobe Acrobat 或 Foxit PDF Editor。PdfCraft 目前还不能可靠地编辑已有文字。`)
};

/**
* | output |
* | --- |
* | "Adobe Acrobat or Foxit PDF Editor. PdfCraft does not edit existing text reliably yet." |
*
* @param {Pc_Alt_Pick_2_PickInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_pick_2_pick = /** @type {((inputs?: Pc_Alt_Pick_2_PickInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Pick_2_PickInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_pick_2_pick(inputs)
	return zh_pc_alt_pick_2_pick(inputs)
});
export { pc_alt_pick_2_pick as "pc.alt.pick.2.pick" }